export type HowToQuestions = typeof HowToQuestions;
export const HowToQuestions = [
  {
    question: 'How to turn on email notifications',
    answer: (
      <ul className="counter">
        <li>
          <p>Log in to Time Machine</p>
        </li>
        <li>
          <p>
            Press the menu button in the top left corner. Then go to settings.
          </p>
        </li>
        <li>
          <p>Select which email reminders you would like to receive.</p>
        </li>
      </ul>
    ),
  },
  {
    question: 'How to do a wellness check',
    answer: (
      <>
        <p>
          Focus on your own internal experience of your physical, emotional,
          spiritual health — as well as your sense of hope.
        </p>
        <p css={{ margin: '1rem 0' }}>
          For each of the four wellness checks, move the marker to the left to
          report negative feelings or to the right for positive feelings.
        </p>
        <p>
          You must do all four wellness checks to interact with Time Machine
          each day; because checking in with yourself and being honest about
          what you feel supports wellbeing.
        </p>
      </>
    ),
  },
  {
    question: 'How to record a message in the Time Machine',
    answer: (
      <ul className="counter">
        <li>From the map, press the time machine when it says "Record".</li>
        <li>Press the record button.</li>
        <li>Record your message (1 min max).</li>
        <li>Listen to your message.</li>
        <li>
          Press "Keep" to launch the time machine (send the message). Or press
          "Redo" to start over and record another message.
        </li>
      </ul>
    ),
  },

  {
    question: 'How to listen to a message in the Time Machine',
    answer: (
      <ul className="counter">
        <li>From the map, press the time machine when it says "Listen"</li>
        <li>Press the play button.</li>
        <li>Listen to your message.</li>
        <li>Press "Done" when you're finished listening to the message.</li>
      </ul>
    ),
  },
  {
    question: 'How to listen to saved Time Machine messages',
    answer: (
      <ul className="counter">
        <li>From the map, press the Meditation Tent.</li>
        <li>Press the "Time Travel" card on the list of options.</li>
        <li>Press the message you would like to listen to.</li>
      </ul>
    ),
  },
  {
    question: 'How to listen to a meditation',
    answer: (
      <ul className="counter">
        <li>From the map, press the Meditation Tent.</li>
        <li>Select any card from the list of options.</li>
        <li>Press any meditation in the list of options.</li>
      </ul>
    ),
  },
  {
    question: 'How to create a meditation',
    answer: (
      <ul className="counter">
        <li>From the map, press the Meditation Tent.</li>
        <li>Select any card from the list of options.</li>
        <li>Press “Create my own”.</li>
        <li>Enter a name for your meditation.</li>
        <li>Choose a prompt from the list.</li>
        <li>Select a background photo from your camera roll. (Max size 5MB)</li>
        <li>Press the “Record meditation” button.</li>
        <li>Record yourself saying the prompt for up to 1 minute.</li>
        <li>
          Press “Keep” to save your meditation. Or, press “Redo” to start over
          and record again.
        </li>
      </ul>
    ),
  },
  {
    question: 'How to delete a meditation',
    answer: (
      <ul className="counter">
        <li>From the map, press the Meditation Tent.</li>
        <li>
          Select any card from the list of options. that has the mediation you
          want to delete.
        </li>
        <li>Press the options button on the mediation you want to delete.</li>
        <li>Press delete.</li>
      </ul>
    ),
  },
  {
    question: 'How to create a hope',
    answer: (
      <ul className="counter">
        <li>From the map, press the Hope Garden.</li>
        <li>
          Press the seed button at the button of the screen in “My Garden”.
        </li>
        <li>Enter a name for your hope.</li>
        <li>Select an avatar to represent your hope.</li>
        <li>
          Choose five resources from the list, press “check for more” to reveal
          more options, or press the plus sign and add your own.
        </li>
        <li>Select a check-in schedule from the list of options.</li>
        <li>Review your hope then press “Plant hope”</li>
        <li>
          Choose whether or not you’d like to record a message to accompany your
          or skip.
        </li>
      </ul>
    ),
  },
  {
    question: "How to harvest a hope when you're done with it",
    answer: (
      <ul className="counter">
        <li>From the map, press the Hope Garden.</li>
        <li>Select the hope you want to harvest in "My Garden".</li>
        <li>Press the harvest hope button.</li>
      </ul>
    ),
  },
  {
    question: 'How to delete a Hope',
    answer: (
      <ul className="counter">
        <li>From the map, press the Hope Garden.</li>
        <li>Select the hope you want to delete in "My Garden".</li>
        <li>Press the three dots in the upper right corner.</li>
        <li>Press delete hope</li>
      </ul>
    ),
  },
  {
    question: 'How to share your hope with the Community Garden',
    answer: (
      <ul className="counter">
        <li>From the map, press the Hope Garden.</li>
        <li>Select the hope in “My Garden” you want to share.</li>
        <li>Press the three dots in the upper right corner.</li>
        <li>Press “Share with Community Garden”.</li>
      </ul>
    ),
  },
  {
    question: 'How to water the Community Garden',
    answer: (
      <ul className="counter">
        <li>From the map, press the Hope Garden.</li>
        <li>Press “Community Garden” in the Hope Garden navigation.</li>
        <li>Press the raindrop buttons.</li>
      </ul>
    ),
  },
  {
    question: 'How to remove your hope from the Community Garden',
    answer: (
      <ul className="counter">
        <li>From the map, press the Hope Garden.</li>
        <li>Press “Community Garden” in the Hope Garden navigation.</li>
        <li>Select your hope.</li>
        <li>Press the options button in the top right corner of the screen.</li>
        <li>Press “Remove from Community Garden”.</li>
      </ul>
    ),
  },
  {
    question: 'How to mute a hope in the Community  Garden',
    answer: (
      <ul className="counter">
        <li>From the map, press the Hope Garden.</li>
        <li>Press “Community Garden” in the Hope Garden navigation.</li>
        <li>Select the hope you would like to mute.</li>
        <li>Press the options button in the top right corner of the screen.</li>
        <li>Press “Mute this hope”.</li>
      </ul>
    ),
  },

  {
    question: 'How to mute a user in the Community  Garden',
    answer: (
      <ul className="counter">
        <li>From the map, press the Hope Garden.</li>
        <li>Press “Community Garden” in the Hope Garden navigation.</li>
        <li>Select the hope you would like to mute.</li>
        <li>Press the options button in the top right corner of the screen.</li>
        <li>Press “Mute this user”.</li>
      </ul>
    ),
  },

  {
    question: 'How to Flag a hope in the Community  Garden',
    answer: (
      <ul className="counter">
        <li>From the map, press the Hope Garden.</li>
        <li>Press “Community Garden” in the Hope Garden navigation.</li>
        <li>Select the hope you would like to mute.</li>
        <li>Press the options button in the top right corner of the screen.</li>
        <li>Press “Flag this hope”.</li>
      </ul>
    ),
  },
  {
    question: ' How to check wellness insights',
    answer: (
      <ul className="counter">
        <li>From the map, press the menu</li>
        <li>Press insights</li>
      </ul>
    ),
  },
  {
    question: 'How to read the wellness insights charts',
    answer: (
      <>
        <p>
          Each insight tab takes your daily ratings from the check-ins and
          separates them according to each check-in type (physical, emotional,
          spiritual, hope).
        </p>
        <p css={{ margin: '1rem 0' }}>
          For each day you check-in, a node is placed on the calendar with a
          color-matched to each day’s check-in (green = overall higher, red =
          overall lower).
        </p>
        <p>
          If you don’t check in, no node is placed on the calendar. If there are
          more than 28 nodes, the oldest node is removed. That way, you can see
          patterns over time, like, are Tuesdays generally good days?
        </p>
      </>
    ),
  },
].map((item, idx) => ({ ...item, id: idx }));
